var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplorerFileSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.088 5.763v13.863c0 .746-.603 1.35-1.35 1.35H4.262c-.747 0-1.35-.604-1.35-1.35V1.374c0-.747.603-1.35 1.35-1.35h8.088l5.738 5.739z",
    fill: "#23A566"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.818 10.455H7.182a.43.43 0 0 0-.431.43v5.78c0 .238.193.43.43.43h6.641a.43.43 0 0 0 .43-.43V10.89a.44.44 0 0 0-.434-.435zm-6.206 2.773h2.457v1.095H7.612v-1.095zm3.319 0h2.456v1.095H10.93v-1.095zm2.456-.862H10.93V11.32h2.457v1.046zM10.07 11.32v1.046H7.612V11.32h2.457zm-2.457 3.868h2.457v1.046H7.612v-1.046zm3.319 1.046v-1.046h2.456v1.046H10.93z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "m13.121 5.554 4.967 4.023V5.8L15.27 4.163l-2.149 1.39z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.088 5.763h-4.389c-.746 0-1.35-.603-1.35-1.35V.024l5.739 5.739z",
    fill: "#8ED1B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorerFileSmall);
export default __webpack_public_path__ + "static/media/Explorer_file_small.d99a063bf8db807689e6cf9bade79a48.svg";
export { ForwardRef as ReactComponent };